import React, { useEffect, useRef, useState } from "react";
import IconButton from "../common/IconButton";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import axios from "axios";
import { getCookie } from "src/utils/cookieUtil";
import cn from "classnames";
import { useAppSelector } from "src/store/actions/action";
import { isEmpty } from "lodash";
import { setOnFocusReduce, setWriteNameReduce } from "src/store/reducers/noticeDetailReduce";
import imageCompression from "browser-image-compression";
import { RotatingLines } from "react-loader-spinner";
import VideoPlayer from "react-video-thumbnail";
import { useDispatch } from "react-redux";
import { useGetNoticeDetailQuery } from "../../api/noticeAPI";

const compressionOption = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1024,
  initialQuality: 0.7,
};

const serverIp = process.env.REACT_APP_SERVER_IP;

interface NoticeCommentItemProps {
  noticeData: ModifyNotice;
}

const NoticeCommentInput = (props: NoticeCommentItemProps) => {
  const [imageList, setImageList] = useState<File[]>([]);
  const previewRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputs, setInputs] = useState("");

  const index: any = location.pathname.split("/")[2];
  const reduceOnFocus = useAppSelector((state) => state.noticeDetailReduce.isOnFocus);
  const reduceWriteName = useAppSelector((state) => state.noticeDetailReduce.writeName);
  const noticeCommentIdx = useAppSelector((state) => state.noticeDetailReduce.noticeCommentIdx);
  const [isOnFocus, setIsOnFocus] = useState<boolean>();
  const [render, setRender] = useState(false);

  const [loading, setLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const { refetch } = useGetNoticeDetailQuery(index);

  useEffect(() => {
    if (reduceOnFocus) {
      if (inputRef.current !== null) inputRef.current.focus();
    }
    setIsOnFocus(reduceOnFocus);
  }, [reduceOnFocus]);

  // useEffect(() => {
  //   if (render || isOnFocus) {
  //     previewRef.current?.scrollIntoView({
  //       behavior: "smooth",
  //       block: "start",
  //     });
  //   }
  // }, [render, isOnFocus]);

  const saveFileImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectFiles = e.target.files;
    if (selectFiles !== null) {
      try {
        if (selectFiles.length > 0) {
          if (selectFiles.length > 9 || imageList.length > 9) {
            alert("사진 첨부는 한번에 최대 10개까지 가능합니다.");
            return;
          }
          let totalFileSize = 0;
          for (let i = 0; i < selectFiles.length; i++) {
            totalFileSize += Number(selectFiles[i].size);
            const fileType = selectFiles[i].type;
            const oneFileSize = Number(selectFiles[i].size / 1024);
            // 이미지 로직
            if (String(fileType).indexOf("image") > -1) {
              if (oneFileSize > 10000) {
                // 이미지 파일
                alert("사진 용량은 개당 10MB를 초과할 수 없습니다.");
                return;
              }
            } else if (String(fileType).indexOf("video") > -1) {
              if (oneFileSize > 30000) {
                // 동영상 파일
                alert("영상 용량은 개당 30MB를 초과할 수 없습니다.");
                return;
              }
            }
            if (totalFileSize / 1024 > 150000) {
              alert("파일 첨부는 총 100MB를 초과할 수 없습니다.");
              return;
            }
          }
          for (let i = 0; i < selectFiles.length; i++) {
            const file = selectFiles[i];
            if (String(file.type).includes("image") == true) {
              const compressedFile = await imageCompression(file, compressionOption);
              const newFile = new File([compressedFile], compressedFile.name, { type: file.type });
              setImageList((images) => [...images, newFile]);
            } else {
              setImageList((images) => [...images, file]);
            }
          }
        }
        e.target.value = "";
        setRender(true);
      } catch (error) {
        alert("이미지 업로드 중 오류가 발생하였습니다.");
        e.target.value = "";
        console.error(error);
      }
    }
  };

  const commentSend = async () => {
    if (inputs === "" && isEmpty(imageList)) {
      alert("내용을 입력하세요.");
      return;
    }
    setLoading(true);
    const fd = new FormData();
    fd.append("contents", inputs);
    // fd.append("images", upLoadImg.upload);
    for (let i = 0; i < imageList.length; i++) {
      fd.append("images", imageList[i]);
    }
    if (!isEmpty(noticeCommentIdx)) {
      fd.append("parent_comment_idx", noticeCommentIdx!);
    }
    const response = await axios.post(serverIp + "/common/comment/NOTICE/" + props.noticeData.notice_idx, fd, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + getCookie("ac_token"),
      },
    });
    if (response.status === 201) {
      setLoading(false);
      setInputs("");
      setIsOnFocus(false);
      dispatch(setOnFocusReduce(false));
      dispatch(setWriteNameReduce(["", ""]));
      setImageList([]);
      setRender(false);
      refetch();
    } else {
      setLoading(false);
      console.log(response.data);
    }
  };

  const deleteFileImage = (selectedFile: File) => {
    const removedList = imageList.filter((image) => image !== selectedFile);
    setImageList(removedList);
    setRender(false);
  };

  const enterKeyPress = (e: any) => {
    if (e.key === "Enter") {
      commentSend();
    }
  };

  const setComment = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value.length < 500) {
      setInputs(value);
    }
  };
  const userInfo = useAppSelector((state) => state.userReduce.userInfo);
  return (
    <>
      <CommentInputSet>
        <PreviewBox className={cn({ hasImages: imageList.length > 0 ? true : false })} ref={previewRef}>
          <ul>
            {imageList
              ? imageList.map((image: any, index: number) => (
                  <li key={index}>
                    <div>
                      {(image as File).type.includes("image") === true ? (
                        <img alt="sample" src={URL.createObjectURL(image as File)} />
                      ) : (
                        <VideoPlayer videoUrl={URL.createObjectURL(image as File)} snapshotAt={1} height={70} width={70} renderThumbnail={true} />
                      )}
                    </div>
                    <IconButton btnName="미리보기 삭제하기" onClick={() => deleteFileImage(image as File)}>
                      <SVG name="thumbDel" width={24} height={24} viewBox="0 0 24 24" />
                    </IconButton>
                  </li>
                ))
              : ""}
          </ul>
        </PreviewBox>
        {isOnFocus && (
          <div className="cmt-noti">
            <p>[{reduceWriteName}]님에게 답글 남기는 중</p>
          </div>
        )}
        <div className="cmt-input-wrap">
          <p className="add-file-wrap">
            <label htmlFor="add-file">
              <SVG name="camera" />
            </label>
            <input id="add-file" type="file" accept={"image/*"} name="profile_img" onChange={saveFileImage} multiple />
          </p>
          <div>
            <input
              type="text"
              ref={inputRef}
              placeholder={
                userInfo.user_id == "m1"
                  ? "본 서비스에서는 위반 사항이 확인되는 경우 해당 댓글이 삭제될 수 있습니다."
                  : "댓글은 등록 후 1시간이 지나면 삭제할 수 없어요."
              }
              value={inputs}
              id="commnet"
              onChange={(e) => setComment(e)}
              onKeyPress={enterKeyPress}
            />
            {loading ? (
              <IconButton btnName="">
                <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />
              </IconButton>
            ) : (
              <IconButton btnName="댓글달기" onClick={commentSend}>
                <SVG name="send" />
              </IconButton>
            )}
          </div>
        </div>
      </CommentInputSet>
    </>
  );
};

const PreviewBox = styled.div`
  height: auto;
  max-height: 120px;
  background: ${({ theme }) => theme.color.bgPrimary};
  &.hasImages {
    padding: 0 15px;
    border-top: 1px solid ${({ theme }) => theme.color.bgPrimary};
  }
  > ul {
    overflow-x: scroll;
    white-space: nowrap;
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera*/
    }
    > li {
      position: relative;
      display: inline-block;
      width: 100px;
      height: 100px;
      margin: 10px 10px 10px 0;
      border: 1px solid #707070;
      background: #fff;
      > button {
        position: absolute;
        top: -5px;
        right: -5px;
      }
      > div {
        overflow: hidden;
        position: relative;
        width: 100%;
        height: 100%;
        img {
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          display: block;
          object-fit: cover;
          max-width: 100%;
          height: auto;
          box-sizing: border-box;
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

const CommentInputSet = styled.div`
  z-index: 1000;
  position: sticky;
  left: 0;
  right: 0;
  bottom: 0;
  > .cmt-noti {
    padding: 10px 15px;
    background: #f4f4f4;
    box-shadow: none;
    > p {
      color: ${({ theme }) => theme.color.primary};
    }
  }
  > .cmt-input-wrap {
    padding: 8px 15px 7px;
    background-color: #fff;
    box-shadow: 0px 0px 5px ${({ theme }) => theme.color.linePrimary};
    ${({ theme }) => theme.flexBox.flexMixin()}
    .add-file {
      flex-basis: 28px;
    }
    .add-file-wrap {
      > label {
        display: block;
        width: 28px;
        height: 28px;
        cursor: pointer;
      }
      > input {
        display: none;
      }
    }
    > div {
      margin-left: 10px;
      position: relative;
      flex: 1 0 auto;
      > input {
        display: inline-block;
        width: 100%;
        height: 40px;
        line-height: 40px;
        padding: 0 50px 0 15px;
        border: none;
        border-radius: 20px;
        background-color: ${({ theme }) => theme.color.bgPrimary};
        font-size: 16px;
        font-family: "Roboto";
      }
      > button {
        position: absolute;
        top: 50%;
        margin-top: -13px;
        right: 15px;
      }
    }
  }
`;

export default NoticeCommentInput;
